/**
 * IncidentsSidebar - Statistics and quick actions for incidents module
 * Follows DefectsSidebar pattern exactly
 */

import React from 'react';
import {
  AlertTriangle,
  Plus,
  History,
  Settings,
  Shield
} from 'lucide-react';
import IncidentsSummaryCard from './IncidentsSummaryCard';

const IncidentsSidebar = ({ stats, onQuickAction }) => {
  return (
    <div className="space-y-6">
      {/* Summary Card */}
      <IncidentsSummaryCard stats={stats} />

      {/* Quick Actions Card */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="bg-slate-700 px-5 py-3">
          <h3 className="text-base font-semibold text-white flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-white" />
            Quick Actions
          </h3>
        </div>
        <div className="p-6 space-y-2">
          <button
            onClick={() => onQuickAction('report')}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-cyan-600 rounded-md hover:bg-cyan-700"
          >
            <Plus className="h-4 w-4" />
            Report Incident
          </button>
          <button
            onClick={() => onQuickAction('history')}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            <History className="h-4 w-4" />
            History
          </button>
          <button
            onClick={() => onQuickAction('settings')}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            <Settings className="h-4 w-4" />
            Settings
          </button>
        </div>
      </div>

      {/* Reporting Requirements Info */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Shield className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="font-medium text-blue-900">WBC3 Reporting Requirements</h4>
            <ul className="mt-2 space-y-1 text-sm text-blue-700">
              <li>• MAIB: Serious casualties within 24h</li>
              <li>• MCA: Safety-critical incidents</li>
              <li>• Harbourmaster: Port incidents immediately</li>
              <li>• SMS Records: All incidents per WBC3</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(IncidentsSidebar);
